module.exports = __webpack_public_path__ + "assets/yongyin.e3812ace.svg";